import { put, takeEvery, delay, race, take } from 'redux-saga/effects';
import * as types from './constants';
import { hideAppLoader } from './actions';

const LOADER_TIMEOUT = 15000;

function* autoHideLoaderSaga() {
  const { timedOut } = yield race({
    timedOut: delay(LOADER_TIMEOUT),
    hidden: take(types.HIDE_LOADER)
  });

  if (timedOut) {
    yield put(hideAppLoader());
  }
}

export function* layoutSaga() {
  yield takeEvery(types.SHOW_LOADER, autoHideLoaderSaga);
}


